<template>
  <div class="device-block-page">
    <div class="container">
      <div class="chart-block block-odd">
        <!-- <img src="/static/images/device/sjtj.png" class="titl"> -->
        <div class="item">
          <div class="chart-box">
            <v-chart :options="options_sjtj" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    return {
      sjtjList: [],
      options_sjtj: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //时间统计
      this.getSjtjList();
    },
    getSjtjList() {
      let self = this;
      let totalData = [];
      let recentData = [];
      this.$handleRequest(window.ApiHost2+'/InteractAPI/CalcuTotalDuration_FieldStutas/'+window.PYKScadaCode+'/自动/-1', {}, 'get', function(res) {  //success
        totalData = res;
        self.$handleRequest(window.ApiHost2+'/InteractAPI/CalcuTotalDuration_FieldStutas/'+window.PYKScadaCode+'/自动/1', {}, 'get', function(res) {  //success
          recentData = res;
          console.log('--recentData--', res, totalData, recentData);
          totalData.forEach( function(t, ti) {
            recentData.forEach( function(r, ri) {
              if(t.Field == r.Field) {
                let tmp = {
                  field: t.Field,
                  lists: [
                    {
                      label: '历史运行总时长',
                      count: t.TotalDuration
                    },
                    {
                      label: '最近一次运行总时长',
                      count: r.TotalDuration
                    },
                  ]
                };
                self.sjtjList.push(tmp);
              }
            });
          });
          self.setOptionsSjtj();
        }, function(res) {
          //fail
        });
      }, function(res) {
        //fail
      });
    },
    setOptionsSjtj() {
      let self = this;
      let colors = this.$charts.colors.style_14;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let xdata = [];
      let sdata = [];

      this.sjtjList.forEach( function(d, di) {
        d.lists.forEach( function(t, ti) {
          if(legendData.indexOf(t.label) == -1) {
            legendData.push(t.label);
          }
          if(di == 0) {  //
            let tmpdata = [];
            self.sjtjList.forEach( function(dd) {
              dd.lists.forEach( function(tt) {
                if(tt.label == t.label) {
                  tmpdata.push(tt.count)
                }
              })
            });
            let stack = '';
            let markPoint = {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            }
            let tmp = {
              name: t.label,
              type:'bar',
              barWidth: 15,//柱图宽度
              barGap: '50%',
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: colors[ti][0]}, {offset: 1, color: colors[ti][1]}
              ]),
              stack: stack,
              markPoint: markPoint,
              data: tmpdata
            }
            sdata.push(tmp)
          }
        });
        xdata.push(d.field);
      });

      this.options_sjtj = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          },
          textStyle: {
            fontSize: 20,
          }
        },
        legend: {
          //right: 100,
          textStyle: {
            color: chartsConf.legend.color,
            fontSize: 16
          },
          data: legendData
        },
        xAxis: [
          {
            type: 'category',
            nameRotate: 180,
            axisLabel: {
              //rotate: -25,
              color: chartsConf.xAxis.color,
              fontSize: 20
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.xAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis: [
          {
            name: '运行时长(h)',
            type: 'value',
            nameTextStyle: {
              color: chartsConf.yAxis.color,
              fontSize: 20
            },
            axisLabel: {
              color: chartsConf.yAxis.color,
              fontSize: 20,
              formatter: function(val, index) {
                if (val >= 1000) {
                  val = val/1000 + 'k';
                } else if(val < 1000) {
                  val = val;
                }
                return val;
              }
            },
            axisLine:{  //设置轴线的属性
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series : sdata
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintainTime.vue